import { NgModule } from "@angular/core";
import { AdminCommonModule } from "../admin-common.module";
import { UserManagementComponent } from "./user-management.component";
import { UserManagementTableComponent } from "./user-management-table.component";

@NgModule({
    declarations: [
        UserManagementComponent,
        UserManagementTableComponent
    ],
    imports: [
        AdminCommonModule
    ]
})
export class UserModule {
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user.module.ts